import { render } from "./SiteText.vue?vue&type=template&id=540ca68c"
import script from "./SiteText.vue?vue&type=script&lang=js"
export * from "./SiteText.vue?vue&type=script&lang=js"

import "./SiteText.vue?vue&type=style&index=0&id=540ca68c&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__